import * as React from "react";
import C from "classnames";
export const ModalCard = (props) => {
    return (React.createElement("div", { className: C("modal-card", "card", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=ModalCard.js.map